import { LinkNavigationTypes } from '@alme/types/response/LinkNavigationTypes';
import defaultLogger from '../Logger';

const trailingPeriodRegex = /\.$/;

function isHostEqual(windowHost: string, urlHost: string): boolean {
    if (!windowHost || !urlHost) {
        return false;
    }

    const windowsHostParts = windowHost.replace(trailingPeriodRegex, '').split('.').reverse();
    const rootWindowHost = '.' + windowsHostParts[1] + '.' + windowsHostParts[0];

    const urlHostParts = urlHost.replace(trailingPeriodRegex, '').split('.').reverse();
    const rootUrlHost = '.' + urlHostParts[1] + '.' + urlHostParts[0];

    return rootWindowHost === rootUrlHost;
}

export function isExternal(url: string): boolean {
    try {
        const windowHost = window.location.hostname;
        const urlLink = getLocation(url);
        return !isHostEqual(windowHost, urlLink.hostname);
    } catch (ex) {
        defaultLogger.warn(ex);
    }
    return true;
}

export function getQueryValue(key: string): string | undefined {
    const nvString = window.location.search.substring(1);
    return parseKey(key, nvString);
}

export function parseKey(key: string, nvString: string): string | undefined {
    const vars = nvString.split("&");
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0] === key)
            return decodeURIComponent(pair[1]);
    }
    return undefined;
}

export function getLocation(url: string): Location {
    const urlLink = document.createElement('a');
    urlLink.href = url;
    return urlLink as unknown as Location;
}

export function openNavLink(navigationType: LinkNavigationTypes, url: string): void {
    switch (navigationType) {
        case 'MainPage':
            window.open(url, '_self');
            break;
        case 'None':
            break;
        case 'Popup':
        default:
            window.open(url, '_blank');
            break;
    }
}
export function openWindow(urlAddress: string, target: string): void {
    window.open(urlAddress, target);
}